import { AppSyncFarmToken } from 'common/models/farm';
import { ChainId } from 'constants/constants';
import isUndefined from 'lodash/isUndefined';
import React from 'react';
import TokenBalance from '../Farm/TokenBalance';
import { TokenIcon } from '../TokenIcons/TokenIcon';

type Props = {
  token: AppSyncFarmToken | undefined;
  value: string;
  label: string;
  isNumber: boolean;
  placeholder?: string;
  step?: string;
  onChange: (value: string) => void;
  ref?: React.RefObject<HTMLInputElement>;
  isDisabled?: boolean;
  tokenBalance: bigint;
  selectedToken: string;
  chainId?: ChainId;
  isLoading?: boolean;
};

const GeneralInput: React.FC<Props> = (props) => {
  const token = props.token;
  if (!token) {
    return null;
  }
  const isSelectedTokenEth =
    props.selectedToken === 'eth' &&
    token.name === 'weth' &&
    props.chainId !== ChainId.Polygon &&
    props.chainId !== ChainId.Celo;
  const tokenDisplayName = isSelectedTokenEth ? 'ETH' 
    : (token.displayName === 'ETHC' ? 'ETH' : token.displayName);
  const onChange = (event: React.ChangeEvent<HTMLInputElement>) => {
    if (props.onChange && event.target.validity.valid) {
      if (event.target.value.match(/^$|^[0-9]*\.?[0-9]*$/)) {
        let tmpValue = event.target.value.replace(
          /^0+((0.([0-9])?)?[1-9]+)/,
          '$1'
        );
        if (tmpValue === '') {
          tmpValue = '0';
        }
        props.onChange(tmpValue);
      }
    }
  };

  const onFocus = (event: React.ChangeEvent<HTMLInputElement>) => {
    if (event.target.value === '') {
      event.target.value = '0';
    }
  };

  const onBlur = (event: React.ChangeEvent<HTMLInputElement>) => {
    if (event.target.value === '0.' || event.target.value === '0') {
      event.target.value = '';
    }
  };

  const value = isUndefined(props.value) ? '' : props.value;
  return (
    <div className="rounded-[10px] input-border input-bg-color input-placeholder-color mt-0 mb-5 px-7 w-full h-24 flex justify-between items-center">
      <input
        className="text-left input-bg-color text-xl pr-1 w-2/3"
        ref={props.ref}
        type="string"
        placeholder={props.placeholder || '0'}
        pattern={props.isNumber ? '[0-9]+.?[0-9]*' : undefined}
        // Note: only the most basic pattrn attr works, don't use it, acks weird
        min={0}
        value={value}
        onChange={onChange}
        onFocus={onFocus}
        onBlur={onBlur}
        disabled={props.isDisabled}
      />
      <div className="flex flex-col justify-center items-end h-full">
        <div className="flex flex-col tablet:flex-row justify-center tablet:justify-start items-center flex-shrink-0 tablet:gap-2 font-semibold text-xl primary-text-color">
          <TokenIcon
            name={token.name}
            width="30px"
            marginLeft="auto"
            marginRight="auto"
          />
          {tokenDisplayName}
        </div>
        <TokenBalance
          token={token}
          availableToken={props.tokenBalance}
          tokenPrice={token.price}
          isLoading={props.isLoading ?? false}
          isDepositing={false}
          amount="0"
          tokenDisplayName={token.displayName}
          onChange={props.onChange}
        />
      </div>
    </div>
  );
};

export default GeneralInput;
